export default __webpack_public_path__ + "static/media/AndroidLogo.74a6ffcf.svg";